/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener("theme:variant:change", function (event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log("Container ———————— ↓");
  //     console.log(container);
  //     console.log("Variant —————————— ↓");
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener("theme:cart:change", function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log("Cart ———————————— ↓");
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener("theme:cart:init", (e) => {
  //   console.log("theme:cart:init");
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener("theme:scroll", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:up", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:down", (e) => {
  //   console.log(e);
  // });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener("theme:resize", (e) => {
  //   console.log(e);
  // });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

/*
 * CUSTOM CODE FOR PRODUCT.FABRIC TEMPLATE
 * This code was migrated from previos theme (Prestige version 4.6.5) and changed from function style into class style
 */

/* ========================================================================
   Fabric‑product logic, wrapped in a class
   ===================================================================== */
class FabricProductPage {
  constructor() {
    /* --- cache DOM elements --- */
    this.addToCartBtn = document.getElementById("product-add-btn");
    this.theadTotal = document.getElementById("thead-total");
    this.qtyInput = document.getElementById("quantity-display");
    this.sampleBtn = document.getElementById("sample-btn");
    this.balanceElem = document.getElementById("balance-fabric-length");
    this.threadQtyInput = document.getElementById("thread-quantity");
    this.threadAddBtn = document.getElementById("thread-add-btn");
    this.threadTotalElem = document.getElementById("thread-total");

    /* --- internal/service states --- */
    this.productVariants = window.productVariants || [];
    this.currentAvailableQty10 = 0;// remaining quantity in decimeters
    this.firstLoad = true;
    this.quantitySelectorValue = "";

    /* --- initialize events --- */
    this.initGlobalListeners();
    this.initThreadQtyButtons();
    this.initAjaxButtons();
    this.initQtyInputListeners();

    /* --- first cart synchronization --- */
    this.pageSync();
  }

  /* ------------------------------------------------------------------ */
  /* 1. Global listeners and service helpers                            */
  /* ------------------------------------------------------------------ */

  initGlobalListeners() {
    document.addEventListener("load", () => (this.quantitySelectorValue = ""));

    /* methods invoked inline via onclick in the template */
    window.fabricMinBtnClicked = this.fabricMinBtnClicked.bind(this);
    window.fabricMaxBtnClicked = this.fabricMaxBtnClicked.bind(this);
    window.minCartBtnClick = this.minCartBtnClick.bind(this);
    window.maxCartBtnClick = this.maxCartBtnClick.bind(this);
    window.changeQuantity = this.changeQuantity.bind(this);
    window.updateCartOnBlur = this.updateCartOnBlur.bind(this);

    document.addEventListener("theme:cart:change", () => {
      if (window.currentTemplate === "product.fabric-product") this.pageSync();
    });
  }

  initThreadQtyButtons() {
    document
      .querySelector('[data-action="increase-quantity"]')
      ?.addEventListener("click", () => this.increaseThreadQuantity());

    document
      .querySelector('[data-action="decrease-quantity"]')
      ?.addEventListener("click", () => this.decreaseThreadQuantity());
  }

  initAjaxButtons() {
    Array.from(document.getElementsByClassName("ajax-cart-add-js")).forEach((btn) =>
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const data = {
          id: btn.dataset.variantid,
          quantity: btn.dataset.qty,
          properties: {
            _isSample: btn.dataset.issample || 0,
            _isFabric: btn.dataset.isfabric || 0,
            _isThread: btn.dataset.isthread || 0,
          },
        };
        this.addAjax(data);
      })
    );
  }

  initQtyInputListeners() {
    if (!this.qtyInput) return;

    this.qtyInput.addEventListener("blur", (e) => this.onQtyBlur(e));
    this.qtyInput.addEventListener("input", (e) => this.onQtyInput(e));
    this.threadQtyInput.addEventListener("blur", (e) => this.onThreadQtyBlur(e));
    this.threadQtyInput.addEventListener("input", (e) => this.onThreadQtyInput(e));
  }

  /* ------------------------------------------------------------------ */
  /* 2. Fabric‑quantity logic                                           */
  /* ------------------------------------------------------------------ */

  fabricMinBtnClicked() {
    if (!this.qtyInput) return;
    const existing = parseFloat(this.qtyInput.value) || 0;
    if (existing <= 0.5) return;

    const newVal = this.changeQuantity(this.qtyInput, 0.1, "down");
    this.updateFabricUi(newVal);
  }

  fabricMaxBtnClicked() {
    if (!this.qtyInput) return;
    const available = this.currentAvailableQty10 / 10;

    const newVal = this.changeQuantity(this.qtyInput, 0.1, "up");
    if (newVal > available) return;

    this.updateFabricUi(newVal);
  }

  onQtyBlur(e) {
    if (e.target.disabled) return;

    let qty = parseFloat(e.target.value) || this.addToCartBtn.dataset.qty / 10;
    qty = Math.max(0.5, qty);
    qty = Math.min(qty, this.currentAvailableQty10 / 10);

    this.updateFabricUi(qty);
  }

  onQtyInput(e) {
    if (e.target.disabled) return;
    const v = parseFloat(e.target.value);
    if (Number.isNaN(v)) e.target.value = this.addToCartBtn.dataset.qty / 10 + "m";
  }

  onThreadQtyBlur(e) {
    if (e.target.disabled) return;

    this.threadQtyInput.value = parseInt(e.target.value, 10) || this.threadAddBtn.dataset.qty;
    this.updateThreadPickButton();
  }

  onThreadQtyInput(e) {
    if (e.target.disabled) return;
    const v = parseFloat(e.target.value);
    if (Number.isNaN(v)) e.target.value = this.threadAddBtn.dataset.qty;
  }

  updateFabricUi(qtyMeters) {
    this.qtyInput.value = `${qtyMeters}m`;
    this.addToCartBtn.dataset.qty = Math.round(qtyMeters * 10);

    if (this.theadTotal) {
      const priceCents = this.qtyInput.dataset.variantprice * qtyMeters * 10;
      this.theadTotal.textContent = new Intl.NumberFormat(window.Shopify.country, {
        style: "currency",
        currency: window.theme.currencyCode,
      }).format(priceCents / 100);
    }
  }

  /* ------------------------------------------------------------------ */
  /* 3. “Thread” logic                                                  */
  /* ------------------------------------------------------------------ */

  updateThreadPickButton() {
    if (!this.threadQtyInput || !this.threadAddBtn) return;
    if (this.threadQtyInput.value === this.threadAddBtn.dataset.qty) return;

    this.threadAddBtn.dataset.qty = this.threadQtyInput.value;

    const totalCents = this.threadAddBtn.dataset.price * this.threadQtyInput.value;
    if (this.threadTotalElem) {
      this.threadTotalElem.textContent = new Intl.NumberFormat(window.Shopify.country, {
        style: "currency",
        currency: window.theme.currencyCode,
      }).format(totalCents / 100);
    }
  }

  increaseThreadQuantity() {
    if (!this.threadQtyInput) return;
    const current = parseInt(this.threadQtyInput.value, 10) || 1;
    this.threadQtyInput.value = current + 1;
    this.updateThreadPickButton();
  }

  decreaseThreadQuantity() {
    if (!this.threadQtyInput) return;
    const current = parseInt(this.threadQtyInput.value, 10) || 1;
    if (current <= 1) return;
    this.threadQtyInput.value = current - 1;
    this.updateThreadPickButton();
  }

  resetThreadQuantityAfterAdd() {
    if (!this.threadQtyInput || !this.threadAddBtn) return;
    this.threadQtyInput.value = 1;
    this.threadAddBtn.dataset.qty = 1;

    const price = this.threadAddBtn.dataset.price / 100;
    if (this.threadTotalElem) {
      this.threadTotalElem.textContent = new Intl.NumberFormat(window.Shopify.country, {
        style: "currency",
        currency: window.theme.currencyCode,
      }).format(price);
    }
  }

  /* ------------------------------------------------------------------ */
  /* 4. AJAX add‑to‑cart                                                */
  /* ------------------------------------------------------------------ */

  async addAjax({id, quantity, properties}) {
    let flag = "";
    Object.entries(properties).forEach(([k, v]) => {
      if (v !== 0) flag = k;
    });

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({id, quantity}),
      });
      if (!res.ok) throw new Error("Network error");

      const variant = await res.json();
      this.updateCartIcon(variant);
    } catch (err) {
      console.error(err);
    } finally {
      this.pageSync(flag);
    }
  }

  updateCartIcon(variant) {
    document.querySelector("[data-product-add-popdown-wrapper]").dispatchEvent(
      new CustomEvent("theme:cart:popdown", {
        detail: {variant},
        bubbles: true,
      })
    );
  }

  /* ------------------------------------------------------------------ */
  /* 5. Utility helpers                                                 */
  /* ------------------------------------------------------------------ */

  changeQuantity(target, step, dir) {
    let val = parseFloat(target.value) || 0;
    const min = parseFloat(target.dataset.minquantity) || 1;

    val = dir === "up" ? val + step : val - step;
    if (val < min) val = min;
    return Math.round(val * 10) / 10;
  }

  disableActionButtons(balance10) {
    const disable = balance10 < 5;
    if (this.addToCartBtn) this.addToCartBtn.disabled = disable;
    if (this.qtyInput) this.qtyInput.disabled = disable;
  }

  updateBalanceFabricLength(balance10) {
    if (!this.balanceElem) return;
    const meters = Math.round(balance10) / 10;
    if (parseFloat(this.balanceElem.textContent) !== meters) {
      this.balanceElem.textContent = meters > 0 ? meters : 0;
    }
  }

  /* ------------------------------------------------------------------ */
  /* 6. Cart synchronization                                            */
  /* ------------------------------------------------------------------ */

  async getCart() {
    try {
      const res = await fetch(`${window.theme.routes.cart}.js`);
      const data = await res.json();
      return data;
    } catch (error) {
      console.warn(error);
    }
  }

  async pageSync(flag = "") {
    clearTimeout(this._psTimeout);
    this._psTimeout = setTimeout(async () => {
      const cart = await this.getCart();

      if (flag) {
        document.dispatchEvent(new CustomEvent("theme:cart:change", {detail: {cart}, bubbles: true}));
        if (flag === "_isThread") this.resetThreadQuantityAfterAdd();
        else if (flag === "_isFabric") this.resetOrderFabricValues();
      }

      let sampleInCart = false;

      this.productVariants.forEach((variant) => {
        if (!variant.isFabric && !variant.isSample) return;

        let balance10 = variant.availableQty;  // measured in dm — decimeters 

        cart.items.forEach((item) => {
          if (Number(item.variant_id) === Number(variant.variantId)) {
            if (variant.isFabric) balance10 -= item.quantity;
            if (variant.isSample) sampleInCart = true;
          }
        });

        if (variant.isFabric) {
          this.currentAvailableQty10 = balance10;
          this.updateBalanceFabricLength(balance10);
          this.disableActionButtons(balance10);
        }
      });

      if (this.sampleBtn) {
        if (sampleInCart) this.disableSampleButton(true);
        else if (this.checkMinQuantityForSampleBtn()) this.restoreSampleBtnHTML();
        else this.disableSampleButton(false);
      }

      this.firstLoad = false;
    }, 100);
  }

  /* ------------------------------------------------------------------ */
  /* 7. Other auxiliary methods                                          */
  /* ------------------------------------------------------------------ */

  checkMinQuantityForSampleBtn() {
    return this.currentAvailableQty10 / 10 >= 3;
  }

  restoreSampleBtnHTML() {
    if (!this.sampleBtn) return;
    if (this.sampleBtn.children.length > 0) return;
    const sampleButtonHtml = this.createSampleBtnHtml();
    this.sampleBtn.disabled = false;
    this.sampleBtn.classList.add("custom-button--primary");
    this.sampleBtn.innerHTML = "";
    this.sampleBtn.appendChild(sampleButtonHtml);
  }
  disableSampleButton(inCart = false) {
    if (!this.sampleBtn) return;
    this.sampleBtn.disabled = true;
    this.sampleBtn.classList.remove("custom-button--primary");
    this.sampleBtn.textContent = inCart ? "Sample in cart" : "Sold out";
  }

  createSampleBtnHtml() {
    const sampleButtonInnerHtml = document.createDocumentFragment();
    const firstSpan = document.createElement("span");
    firstSpan.textContent = "Add Sample";
    const secondSpan = document.createElement("span");
    secondSpan.classList.add("custom-button__separator-dot");
    const thirdSpan = document.createElement("span");
    thirdSpan.textContent = this.sampleBtn.dataset.sampleOriginalPrice;
    thirdSpan.setAttribute("data-money-convertible", true);
    sampleButtonInnerHtml.appendChild(firstSpan);
    sampleButtonInnerHtml.appendChild(secondSpan);
    sampleButtonInnerHtml.appendChild(thirdSpan);
    return sampleButtonInnerHtml;
  }

  resetOrderFabricValues() {
    if (!this.addToCartBtn) return;
    this.addToCartBtn.dataset.qty = 5;

    const priceUsd = new Intl.NumberFormat(window.Shopify.country, {
      style: "currency",
      currency: window.theme.currencyCode,
    }).format(this.addToCartBtn.dataset.originalPrice);

    if (this.theadTotal) this.theadTotal.textContent = priceUsd;
    if (this.qtyInput) this.qtyInput.value = "0.5m";
  }

 /* ---- methods triggered by inline clicks in the cart ------------- */
  minCartBtnClick(el) {
    this.cartBtnChange(el.nextElementSibling, "down");
  }
  maxCartBtnClick(el) {
    this.cartBtnChange(el.previousElementSibling, "up");
  }

  cartBtnChange(input, dir) {
    const original = input.value;
    const newVal = this.changeQuantity(input, 0.1, dir);
    input.value = `${newVal}m`;

    if (dir === "down" && newVal < 0.5) {
      input.value = original;
      if (this.addToCartBtn) this.addToCartBtn.dataset.qty = original.replace("m", "");
      return;
    }
    this.updateCartOnBlur(input, "btn");
  }

  updateCartOnBlur(target, trigger = "txt") {
    if (target.dataset.original == target.value) return false;

    let qty10 = parseFloat(target.value) * 10;
    if (target.dataset.isfabric && qty10 < 5 && trigger === "txt") {
      const warn = target.parentElement.parentElement.parentElement.nextElementSibling;
      warn.style.display = "block";
      target.classList.add("animate__animated", "animate__shakeX");
      setTimeout(() => target.classList.remove("animate__animated", "animate__shakeX"), 750);
      return false;
    }

    document.querySelector(".PageTransition").style.opacity = "1";

    fetch(`${window.theme.localeRootUrl}/cart/change.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({id: target.dataset.lineId, quantity: qty10}),
    }).then(() => location.reload());
  }
}

/* initialize the class when the DOM is ready */
document.addEventListener("DOMContentLoaded", () => new FabricProductPage());
